// Левое меню настроек в окнах «Поля контактов», «Жизненный цикл» и «Теги» — статичная разметка интерфейса.

import { t } from "@/lib/i18n";

export const settingsNav = [
  {
    group: t("Рабочее пространство"),
    items: [
      { id: "dashboard", label: t("Дашборд"), icon: "ri-dashboard-line" },
      { id: "general", label: t("Общие сведения"), icon: "ri-information-line" },
      { id: "user-settings", label: t("Настройки пользователей"), icon: "ri-user-settings-line" },
      { id: "team-settings", label: t("Настройки команды"), icon: "ri-team-line" },
      { id: "apps", label: t("Приложения"), icon: "ri-apps-line" },
      { id: "channels", label: t("Каналы"), icon: "ri-share-forward-line" },
      { id: "integrations", label: t("Интеграции"), icon: "ri-links-line" },
      { id: "widgets", label: t("Виджеты"), icon: "ri-layout-grid-line" },
    ],
  },
  {
    group: t("Настройки входящих"),
    items: [
      { id: "contact-fields", label: t("Поля контактов"), icon: "ri-contacts-book-2-line" },
      { id: "lifecycle", label: t("Жизненный цикл"), icon: "ri-refresh-line" },
      { id: "conversations", label: t("Диалоги"), icon: "ri-chat-3-line" },
      { id: "snippets", label: t("Шаблоны"), icon: "ri-file-copy-2-line" },
      { id: "tags", label: t("Теги"), icon: "ri-price-tag-3-line" },
      { id: "ai-assist", label: "AI Assist", icon: "ri-sparkling-line" },
      { id: "ai-prompts", label: "AI Prompts", icon: "ri-question-answer-line" },
      { id: "calls", label: t("Звонки"), icon: "ri-phone-line" },
    ],
  },
  {
    group: t("Данные"),
    items: [
      { id: "files", label: t("Файлы"), icon: "ri-folder-line" },
      { id: "import", label: t("Импорт контактов"), icon: "ri-upload-cloud-2-line" },
      { id: "data-export", label: t("Экспорт данных"), icon: "ri-download-cloud-2-line" },
    ],
  },
];

// разделы страницы, до которых можно доскроллить
export const settingsNavAnchors: Record<string, string> = {
  dashboard: "#dashboard",
  general: "#general-settings",
  "contact-fields": "#fields",
  lifecycle: "#lifecycle",
  conversations: "#conversations",
  snippets: "#snippets",
  tags: "#tags",
  "ai-assist": "#ai-assist",
  "ai-prompts": "#ai-prompts",
  "ai-knowledge": "#ai-knowledge",
  channels: "#channels",
  widgets: "#widgets",
  calls: "#catalog",
  import: "#contacts-import",
  "data-export": "#data-export",
  "user-settings": "#user-settings",
  "team-settings": "#team-settings",
};

export const navLabel = (id: string) => settingsNav.flatMap((g) => g.items).find((x) => x.id === id)?.label ?? "";
